module.exports = __webpack_public_path__ + "img/completar.d1bd7bdd.svg";